import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import '../src/assets/scss/_primeflex.scss';
import '../src/assets/scss/_primereact.scss';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import "primeicons/primeicons.css"; 
import '../src/assets/scss/Style.scss';
import { PrimeReactProvider } from 'primereact/api';
import { ThemeProvider } from './context/ThemeContext';
import Router from './Router';
import * as serviceWorkerRegistration from './serviceWorker';

const loadReCaptcha = () => {
  const existingScript = document.querySelector(`script[src*="recaptcha/api.js"]`);
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};

loadReCaptcha();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <PrimeReactProvider>
    <ThemeProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeProvider>
  </PrimeReactProvider>
);

reportWebVitals();
serviceWorkerRegistration.register();

